import { useEffect, useState } from "react";
import axios from "axios";
import { ReactLenis } from "lenis/react";
import { API } from "../config";
import Seo from "../components/Seo";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Volume from "../components/Volume";
import Fleet from "../components/Fleet";
import History from "../components/History";
import Experience from "../components/Experience";
import Routes from "../components/Routes";
import Reviews from "../components/Reviews";
import Gallery from "../components/Gallery";
import Conditions from "../components/Conditions";
import Faq from "../components/Faq";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";
import CookieBanner from "../components/CookieBanner";
import BookingModal from "../components/BookingModal";

export default function Home() {
  const [bikes, setBikes] = useState([]);
  const [booking, setBooking] = useState({ open: false, bike: null });

  useEffect(() => {
    axios.get(`${API}/bikes`).then(({ data }) => setBikes(data.bikes)).catch(() => {});
  }, []);

  const openBooking = (bike) => setBooking({ open: true, bike });
  const closeBooking = () => setBooking({ open: false, bike: null });

  return (
    <ReactLenis root options={{ lerp: 0.09, anchors: true }}>
      <div className="grain bg-topacio-sand min-h-screen" data-testid="home-page">
        <Seo />
        <Header onBook={openBooking} />
        <Hero onBook={openBooking} />
        <Marquee />
        <Volume bikesCount={bikes.reduce((s, b) => s + (b.stock || 1), 0)} />
        <Fleet bikes={bikes} onBook={openBooking} />
        <History />
        <Experience />
        <Routes />
        <Reviews />
        <Gallery />
        <Conditions />
        <Faq />
        <Contact />
        <Footer />
        <WhatsAppButton />
        <CookieBanner />
        <BookingModal bike={booking.bike} bikes={bikes} open={booking.open} onClose={closeBooking} />
      </div>
    </ReactLenis>
  );
}
